import React from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../../widgets/tables/Table';
import WaitDialog from '../../../widgets/WaitDialog';
import GetCorsi from '../../../services/getCorsi';
import getStudenti from '../../../services/getStudentiForBilling';
import GestioneRateWidget from "../../../widgets/GestioneRateWidget";
import getPianoPagamentiCorso from "../../../services/getPianoPagamentiCorso";
import addPianoPagamentiCorso from "../../../services/addPianoPagamentiCorso";
import getPianoPagamentiCorsoStudenti from "../../../services/getPianoPagamentiCorsoStudenti";
import getRataStatusAll from "../../../services/getRataStatusAll";
import getRataStatus from "../../../services/getRataStatus";
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../../utils/Locales";
import Utils from "../../../utils/utils";

let t = translateString;

export default class EditCorso extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }
    
    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
        stopScroll: false,
        isLoading: true,
    }
  }

  async reload(){
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentCourse = cookies.get('currentCourse', { path: '/' });
    
    this.corsi = await GetCorsi(username, token);
    this.corso = this.corsi.find(c => c.id == currentCourse);

    this.studenti = await getStudenti(username, token);
    this.studenti = this.studenti.filter(s => s.corsi.indexOf(currentCourse+";") != -1);
    
    for (var i = 0;  i < this.studenti.length; i++){
      var s = this.studenti[i];
      if (s == undefined) continue;
      var pianoRateCorsoStudente = await getPianoPagamentiCorsoStudenti(username, token, this.corso.id, s.id);
      this.studenti[i].piano = pianoRateCorsoStudente != undefined && pianoRateCorsoStudente != null ? 'OK' : '';
    }

    const pianoPagamentiCorso = await getPianoPagamentiCorso(username, token, this.corso.id);
    const costoCorso = parseInt(pianoPagamentiCorso !=  undefined ? pianoPagamentiCorso.costo : 0);
    this.costoTotale = 0;
    this.totalePagato = 0;

    this.costoStudente = [];
    for (var s of this.studenti){
      const pianoStudente = await getPianoPagamentiCorsoStudenti(username, token, this.corso.id, s.id);
      this.costoTotale += pianoStudente != undefined ? parseInt(pianoStudente.costo) : costoCorso;
      this.costoStudente[s.id] = pianoStudente != undefined ? parseInt(pianoStudente.costo) : costoCorso;
    };


    for (var i = 0;  i < this.studenti.length; i++){
      var s = this.studenti[i];
      var rate = await getRataStatus(username, token, this.corso.id, s.id);
      var totalePagato = 0;
      for (var r of rate) {
        if (r.status == 'PAGATA')
          totalePagato += parseInt(r.importo);
      }

      var percentualePagato = (totalePagato / this.costoStudente[s.id]) * 100;
      this.studenti[i].percent_pagamento = percentualePagato ? parseFloat(percentualePagato.toFixed(2)) : '0%';

    };

    var rate = await getRataStatusAll(username, token);
    rate = rate.filter(r => r.id_corso == this.corso.id && r.status == 'PAGATA');
    for (var r of rate){
      this.totalePagato += parseInt(r.importo);
    }

    this.pianoRate = await getPianoPagamentiCorso(username, token, this.corso.id);
    console.error(this.pianoRate);

    this.setState({
      costo: "0", 
      isLoading: false,
    });
  }

  async componentDidMount(){
    await this.reload();
  }

  componentDidUpdate() {
    if (this.state.stopScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  }

  render () {

    const cookies = new Cookies();
    const currentCourse = cookies.get('currentCourse', { path: '/' });

    var headCells = [
        { id: 'cognome', numeric: true, disablePadding: false, label: t('cognome') },
        { id: 'nome', numeric: false, disablePadding: true, label: t('nome') },
        { id: 'mail', numeric: true, disablePadding: false, label: 'Mail' },
        { id: 'piano', numeric: true, disablePadding: false, label: t('piano_rate') },
        { id: 'percent_pagamento', numeric: true, disablePadding: false, label: t('perc_pagamento') },
        { id: '_', numeric: true, disablePadding: false, label: '' },
      ];

      this.searchCols = ['nome', 'cognome', 'mail', 'percent_pagamento'];

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.corso == undefined) return <div></div>;

    return (
      <div id={Math.random()}>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: () => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('piano_rateale') + " " + this.corso.name} />

        <GestioneRateWidget 
            piano={this.pianoRate}
            custom={false}
            isStudent={false}
            corso={this.corso}
            onOpen={() => this.setState({ stopScroll: !this.state.stopScroll })}
            onSalva={async (costo, rate) => {
                    var json ={
                      costo: costo, 
                      rate: rate
                    };
                    const cookies = new Cookies();
                    const username = cookies.get('username', { path: '/' });
                    const token = cookies.get('token', { path: '/' });
                    await addPianoPagamentiCorso(username, token, this.corso.id, JSON.stringify(json));
                    Utils.showSuccess(t('salvataggio_fatto'));
           }} />

          <div style={{ fontFamily: 'Teko', fontWeight: 'bold', marginBottom: 10, fontSize: 18, marginTop: 20 }}>{t('totale_pagato')} {this.totalePagato}<br/>{t('totale_atteso')} { this.costoTotale - this.totalePagato}</div>
        <div style={{ zIndex: 999 }}>
        { this.studenti && <Table students={true} currentCourse={currentCourse} addPerson={false} removePerson={false} headCells={headCells} searchCols={this.searchCols} calendar={false} excel={false} rows={this.studenti} 
            onEventClick={(row) => {
              cookies.set('currentStudent', row, { path: '/' });
              window.location.href =  '/' + this.dbPath + '/#/billing/editStudente';
            }}
        />
        }
        </div>

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </div>
    );
  }
}

